var $ = require('jquery');

var unavailable = function unavailable(blocked, date) {
	if(blocked) {
		var month = (date.getMonth() + 1).toString();
		if(month.length === 1) month = '0' + month;

		var day = (date.getDate()).toString();
		if(day.length === 1) day = '0' + day;

		var dmy = date.getFullYear() + '-' + month + '-' + day;
		if($.inArray(dmy, blocked) === -1) {
			return [true, ""];
		} else {
			return [false, "", 'Unavailable'];
		}
	} else {
		return [true, ""];
	}
}

module.exports = unavailable;